var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1.2em",
      height: "1.2em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M952.52275 496.376064c-6.026053-9.051497-151.236089-221.765066-442.096433-221.765066-290.828734 0-436.041028 212.713569-442.094174 221.765066a27.935688 27.935688 0 0 0 0 30.96339c6.053146 9.049239 151.265441 221.765066 442.094174 221.765066 290.858085 0 436.07038-212.715827 442.096433-221.765066a27.827314 27.827314 0 0 0 0-30.96339z m-442.096433 196.906751c-216.490859 0-345.776672-135.058994-383.791154-181.481501 37.876756-46.512819 166.482974-181.366354 383.791154-181.366353 216.522468 0 345.776672 135.058994 383.793412 181.476985-37.874498 46.512819-166.480716 181.370869-383.793412 181.370869z",
    fill: "#040000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.426317 386.256665c-69.291705 0-125.659796 56.340997-125.659796 125.601094 0 69.262354 56.368091 125.601094 125.659796 125.601094 69.291705 0 125.659796-56.33874 125.659797-125.601094 0-69.260096-56.365833-125.601094-125.659797-125.601094z m0 195.378225c-38.477329 0-69.80874-31.306575-69.80874-69.777131 0-38.475072 31.331411-69.779389 69.80874-69.779389 38.506681 0 69.810998 31.304317 69.810998 69.779389 0 38.470556-31.304317 69.777131-69.810998 69.777131z",
    fill: "#040000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.839fcf6189ac017b57d41a3fb97815ad.svg";
export { ForwardRef as ReactComponent };